import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Publisher / Dashboard
// Component:
// ----------------------------------------------

const ADDRS_API = config.API;
//const ADDRS_API = config.COMP_API + '/pub';
//const DASHB_API = config.COMP_API + '/pub/dash';

// API description for all commnication with BACK-END for accounts management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                      Actions                     View
//  GET       api/pub/char/:id          dane do wykresu             http://localhost:4200/pub/dashboard
//  GET       api/pub/lconv/:id         dane do tabeli last conversions
//  GET       api/                  update Advertisers by :id http://localhost:4200/adm/advertisers
//  GET       api/adm/advertisers/:id   update Advertisers by :id http://localhost:4200/adm/advertisers

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  constructor(private http: HttpClient) { }

   // -------------------------------------
  // Dashboard view

  getChart(): Observable<any> {
    return this.http.get(ADDRS_API + `/publishers/dashboard/offers-daily-statistics-chart`);
  }

  getLastConversions(): Observable<any> {
    return this.http.get(ADDRS_API + '/publishers/dashboard/last-conversions');
  }

  getOffers(): Observable<any> {
    return this.http.get(ADDRS_API + '/publishers/dashboard/offers-statistics');
  }

  getChart2(): Observable<any> {
    return this.http.get(ADDRS_API + `/publishers/dashboard/revenue-daily-statistics-chart`);
  }
}
